'use strict';
const ajaxErrorHandling = require('../components/ajaxErrorHandling');
const keydownHandler = function (e) {
    if (e.keyCode == 27) {
        $content.find('.btn-close').click();
        return false;
    }
};
/**
 * display popup of Error
 * @param {Object} err - Error data
 */
function createErrorNotification(errData) {
    // 警告メッセージダイアログ
    var dialog = '<div class="modal-base modal-paypal-wrapper jsModalContentOuter">';
    dialog += '<div class="modal-paypal__description">' + errData.responseJSON.errorMessage + '</div>';
    dialog += '<ul class="modal-paypal-buttons">';
    dialog += '<li><button type="button" class="button-gray btn-close" onclick="$.magnificPopup.close();">Close</button></li>';
    dialog += '</ul>';
    dialog += '</div>';

    $.magnificPopup.open({
        items: {
            src: dialog,
            type: 'inline'
        },
        mainClass: 'mfp-fade',
        removalDelay: 600,
        callbacks: {
            open: function() {
                var $content = $(this.content);

                $content.on('click', '.btn-close', function() {
                    $.magnificPopup.close();
                    $(document).off('keydown', keydownHandler);
                });

                $(document).on('keydown', keydownHandler);
            },
            close: function() {
                $(document).off('keydown', keydownHandler);
            }
        }
    });
}

/**
 * Display popup waitlist
 * @param {data} data - Modal data
 * @param {closeBtnUrl} closeBtnUrl - Close button image url
 * @param {btn} btn - Current button that fires click event
 */
function popupWaitlistDialog(closeBtnUrl, btn) {
    $.magnificPopup.open({
        items: {
            src: '#waitlist-modal',
            type: 'inline'
        },
        settings: null,
        closeOnBgClick: true,
        mainClass: 'mfp-fade',
        removalDelay: 600,
        closeMarkup: '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom" onclick="$.magnificPopup.close();"><img src="' + closeBtnUrl + '"></button>',
        callbacks: {
            open: function() {
                var $content = $(this.content);

                $content.off('click').on('click', '.btn-close', function() {
                    $.magnificPopup.close();
                    $(document).off('keydown', keydownHandler);
                });


                $content.off('click').on('click', '.button-continue', function() {
                    const modal = $('#waitlist-modal');
                    modal.spinner().start();
                    addToWaitlist(btn);
                    $(document).on('keydown', keydownHandler);
                });

                var keydownHandler = function (e) {
                    if (e.keyCode == 27) {
                        $content.find('.btn-close').click();
                        return false;
                    }
                };
                $(document).on('keydown', keydownHandler);
            },
            close: function() {
                $(document).off('keydown', keydownHandler);
            }
        }
    });
}

/**
 * Add current product to waitlist.
 * Moved the code into function for re-calling
 * @param {btn} btn Current button that fires click event
 */
function addToWaitlist(btn) {
    // Product-AddToWaitlist
    var button = $(btn);
    var url = $('.add-to-waitlist').val();
    var pid = button.data('pid');
    const csrfName = $('input.csrf').attr('name');
    const csrfToken = $('input.csrf').val();
    var pidsObj;

    var form = {
        pid: pid,
        pidsObj: pidsObj,
        childProducts: [],
        quantity: 1
    };
    form[csrfName] = csrfToken;
    $.spinner().start();
    button.attr('disabled', true);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form,
        success: function (data) {
            button.removeAttr('disabled');
            if (data.success) {
                location.href = data.redirectUrl;
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                button.removeAttr('disabled');
                $.spinner().stop();
                createErrorNotification(err);
            }
        }
    });
}

/**
 * Creates a confirmation modal with "OK" and "Cancel" buttons.
 * @param {function} callback - The function to be called after the user clicks "OK".
 * @param {object} e - The event object that triggered the click on the "waitlist-cancel" element.
 */
function createConfirmationModal(callback, e) {
    // 確認ダイアログ
    var dialog = '<div class="modal-base modal-paypal-wrapper jsModalContentOuter">';
    dialog += '<div class="modal-paypal__description"> Are you sure to cancel this waitlist order? </div>';
    dialog += '<ul class="modal-paypal-buttons">';
    dialog += '<li><button type="button" class="button-basic btn-submit">CONFIRM</button></li>';
    dialog += '<li><button type="button" class="button-gray btn-cancel">CANCEL</button></li>';
    dialog += '</ul>';
    dialog += '</div>';

    $.magnificPopup.open({
        items: {
            src: dialog,
            type: 'inline'
        },
        mainClass: 'mfp-fade',
        removalDelay: 600,
        callbacks: {
            open: function() {
                var $content = $(this.content);
                $content.on('click', '.btn-submit', function() {
                    if (typeof cb == 'function') {
                        cb();
                    }
                    callback(e);
                    $(document).off('keydown', keydownHandler);
                });
                $content.on('click', '.btn-cancel', function() {
                    $.magnificPopup.close();
                    $(document).off('keydown', keydownHandler);
                });
                var keydownHandler = function (e) {
                    if (e.keyCode == 13) {
                        $content.find('.btn-submit').click();
                        return false;
                    } else if (e.keyCode == 27) {
                        $content.find('.btn-cancel').click();
                        return false;
                    }
                };
                $(document).on('keydown', keydownHandler);
            },
            close: function() {
                $(document).off('keydown', keydownHandler);
            }
        }
    });
}

$(() => {
    // Waitlist登録
    $('.add-to-waitlist').click(function (e) {
        var $popupUrl = $('input[name="show_popup_url"]');
        var btn = this;
        var closeBtnUrl = $popupUrl.data('close-btn');
        popupWaitlistDialog(closeBtnUrl, btn);
    });

    // 当選時の処理（カート追加）
    $('.waitlist-winner').click(function (e) {
        e.preventDefault();
        var button = $(this);
        // Waitlist No.を取得
        var waitlistNo = $(this).attr('data-wl-number');
        var url = $(this).attr('data-action-url');
        var pid = $(this).attr('data-pid');
        // 当選後の注文期限
        var wonDate = $(this).attr('data-won-date');

        // URLまたは商品IDが取得できない場合は画面に戻す。
        if (!url || !pid) {
            return;
        }

        const csrfName = $(this).data('csrf-name');
        const csrfToken = $(this).data('csrf-token');

        // dataの作成
        var data = {
            waitlistNo: waitlistNo,
            pid: pid,
            wonDate: wonDate
        };
        data[csrfName] = csrfToken;

        $.spinner().start();
        button.attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: data,
            success: function (data) {
                button.removeAttr('disabled');
                if (data.success) {
                    location.href = data.redirectUrl;
                }
            },
            error: function (err) {
                button.removeAttr('disabled');
                $.spinner().stop();
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err);
                }
            }
        });
    });
    // キャンセルボタン
    $('.waitlist-cancel').click(function (e) {
        var cancelCallback = function (e) {
            e.preventDefault();
            var button = $(e.target);
            var url = $(e.target).attr('data-action-url');
            var pid = $(e.target).attr('data-pid');
            const modal = $('div.modal-paypal-wrapper.jsModalContentOuter');
            modal.spinner().start();

            const csrfName = button.data('csrf-name');
            const csrfToken = button.data('csrf-token');

            // dataの作成
            var data = {
                pid: pid
            };
            data[csrfName] = csrfToken;

            $.spinner().start();
            button.attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data,
                success: function (data) {
                    button.removeAttr('disabled');
                    if (data.success) {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    button.removeAttr('disabled');
                    $.spinner().stop();
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err);
                    }
                }
            });
        };
        createConfirmationModal(cancelCallback, e);
    });
});
